import { render, staticRenderFns } from "./pg-button.vue?vue&type=template&id=e3f12ed0&scoped=true&"
import script from "./pg-button.vue?vue&type=script&lang=js&"
export * from "./pg-button.vue?vue&type=script&lang=js&"
import style0 from "./pg-button.vue?vue&type=style&index=0&id=e3f12ed0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f12ed0",
  null
  
)

export default component.exports